export default __webpack_public_path__ + "static/media/dot-igaming.51c655db.svg";